import React from 'react';

import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../Button';

import arrowRight from '../../assets/arrow-right.png';

import './styles.scoped.css';

const Breadcrumbs = ({
  leftTitle,
  rightTitle,
  middleTitle,
  midItemAction,
  route,
  style,
  wrapStyle,
  color,
  handleCancelDQF,
  handleActivateDQF,
  handleActionOnBehalf,
  handleAiReview,
  status,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="wrap" style={wrapStyle}>
      <div className="navigation-header" style={{ ...style }}>
        <div onClick={() => navigate(route)} className="left-title">
          {leftTitle}
        </div>
        {middleTitle && (
          <div onClick={midItemAction} style={{ display: 'flex', alignItems: 'center' }}>
            {color ? (
              <FontAwesomeIcon icon={faChevronRight} color="#ffff" size="lg" style={{ paddingRight: '8px' }} />
            ) : (
              <img
                style={{ width: '12px', height: '18px', marginRight: '8px' }}
                src={arrowRight}
              />
            )}
            <div className={middleTitle && rightTitle ? 'left-title' : 'right-title'} style={{ color: color || null }}>
              {middleTitle}
            </div>
          </div>
        )}
        {rightTitle && (
          <>
            {color ? (
              <FontAwesomeIcon icon={faChevronRight} color={color} size="lg" />
            ) : (
              <img style={{ width: '12px', height: '18px' }} src={arrowRight} />
            )}
            <div className="right-title">{rightTitle}</div>
          </>
        )}
      </div>
      {location.pathname.includes('/driver-qualification') &&
        location.pathname.match(/\d+/g)?.length > 0 &&
        status !== 'Approved' &&
        status !== 'Rejected' &&
        (
          <div style={{ display: 'flex', gap: '8px' }}>
            {handleAiReview && (
              <Button variant="primary" className="btn-cancel" onPress={handleAiReview} text="AI Review" />
            )}
            {(status === 'Sent' || status === 'Client Review' || status === 'Information Requested') &&
              handleActionOnBehalf && (
              <Button
                variant="primary"
                className="btn-cancel"
                onPress={handleActionOnBehalf}
                text="Action on behalf of Client"
              />
            )}
            {status !== 'Cancelled' && (
              <Button
                variant="dark"
                className="btn-cancel"
                onPress={() => {
                  handleCancelDQF();
                }}
                text="Cancel DQF"
              />
            )}
            {status === 'Cancelled' && (
              <Button
                variant="dark"
                className="btn-cancel"
                onPress={() => {
                  handleActivateDQF();
                }}
                text="Activate DQF"
              />
            )}
          </div>
        )
      }
    </div>
  );
};

export default Breadcrumbs;
